<template>
  <div class="count-down-component">
    <div v-if="render.lastDay === 1"
         class="countdown time"
    >
      {{ hours }} 时 {{ timerData.minutes }} 分 {{ timerData.seconds }} 秒
    </div>
    <div v-else
         class="countdown day"
    >
      只剩最后{{ render.lastDay }}天
    </div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';

  export default {
    name: 'CountDown',
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      render: {
        type: Object,
        required: true,
      },
    },
    computed: {
      hours() {
        return (parseInt((this.timerData.days * 24), 10) + parseInt(this.timerData.hours, 10));
      },
    },
    methods: {
      initCountDown() {
        if (this.render.lastDay !== 1) return;
        new CountDown({
          startTime: this.render.countDown.startTime,
          endTime: this.render.countDown.endTime,
          render: (data) => {
            this.timerData = data;
          },
          end: () => {
            this.$emit('count-down-ended');
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .count-down-component {
    position: relative;
    top: -340px;
    width: 100%;
    height: 197px;
    background: url('~@/pages/2021/ReadingDay/assets/img/countdown_bg.png');
    background-size: 100%;
    .countdown {
      position: absolute;
      top: 55px;
      right: 100px;
      width: 280px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #e15243;
      font-weight: @font-weight-bold;
      &.day {
        font-size: 42px;
      }
      &.time {
        font-size: @font-size-medium;
      }
    }
  }
</style>
